import { FC, SVGAttributes } from "react";

const MastercardIcon: FC<SVGAttributes<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="96"
    height="40"
    viewBox="0 0 96 40"
    {...props}
  >
    <defs>
      <path
        id="prefix__mastercard_a"
        d="M37.055 4.316c.041 0 .085.007.126.024.04.016.075.039.106.068.03.03.054.064.072.102.035.08.035.172 0 .253-.018.038-.042.073-.072.102-.03.03-.067.052-.106.068-.04.018-.085.028-.13.028-.131-.001-.251-.078-.307-.198-.034-.08-.034-.172 0-.253.018-.038.042-.073.072-.102.03-.03.067-.052.106-.068l.069-.02.064-.004zm-.003.085c-.034 0-.068.007-.1.02-.03.013-.058.032-.081.055-.089.097-.089.245 0 .341.023.024.051.042.082.055l.053.016.049.005.047-.006c.017-.003.033-.008.049-.015.029-.013.056-.032.078-.055.089-.096.089-.244 0-.34-.022-.024-.049-.042-.078-.055-.032-.014-.065-.021-.1-.02zM14.71.538v.99h1.168l.006.648h-1.16v1.488c0 .328.13.546.471.546.222-.007.438-.07.628-.184l.205.607c-.266.166-.574.254-.888.253-.839 0-1.132-.45-1.132-1.208V2.176h-.662v-.648h.648v-.99h.716zm-3.262.908c.467-.016.93.102 1.331.341l-.314.573c-.312-.179-.664-.275-1.024-.28-.389 0-.62.164-.62.383 0 .218.245.28.552.32l.341.048c.71.103 1.14.355 1.14.976s-.546 1.065-1.488 1.065c-.504.014-.999-.134-1.412-.423l.34-.553c.314.232.696.353 1.086.341.485 0 .744-.143.744-.396 0-.184-.184-.286-.573-.34l-.342-.049c-.73-.102-1.126-.43-1.126-.962 0-.648.54-1.044 1.365-1.044zm12.783-.015l.154.001c.426-.021.845.117 1.174.39l-.342.573c-.245-.187-.544-.29-.853-.294-.544.044-.963.499-.963 1.044 0 .546.42 1 .963 1.045.309-.004.608-.107.853-.294l.342.573c-.33.272-.748.411-1.174.39-.463.026-.916-.144-1.247-.47-.332-.324-.51-.773-.494-1.237V3.14c-.017-.464.162-.913.494-1.238.33-.325.784-.495 1.247-.469l-.154-.001zm-6.146.015l.01.007c.915 0 1.55.682 1.55 1.706v.273h-2.423c.055.486.488.84.976.798.345-.005.68-.125.949-.34l.34.525c-.38.31-.863.469-1.354.443-.942.014-1.717-.74-1.73-1.682-.013-.942.74-1.717 1.682-1.73zm9.473 0c.398-.015.78.163 1.024.478v-.396h.71v3.248h-.71v-.395c-.245.314-.626.492-1.024.477-.942 0-1.706-.764-1.706-1.706s.764-1.706 1.706-1.706zm8.31-1.229v4.56h-.683V4.38c-.245.314-.625.492-1.024.477-.942 0-1.706-.764-1.706-1.706s.764-1.706 1.706-1.706c.399-.015.78.163 1.024.478V.217h.682zM7.543 1.446c.399-.015.78.163 1.024.478v-.396h.71v3.248h-.71v-.395c-.244.314-.625.492-1.024.477-.942 0-1.706-.764-1.706-1.706s.764-1.706 1.706-1.706zm-3.689-.002l.137.002c.349-.02.69.11.935.358.245.248.372.59.348.939V4.79l-.716.014V2.988c0-.552-.233-.86-.717-.86-.227-.01-.448.08-.602.247-.154.167-.226.395-.197.62v1.809h-.716V2.988c0-.552-.24-.86-.71-.86-.228-.012-.449.078-.603.246-.155.167-.226.395-.196.621V4.79H.103V1.528h.71v.403c.21-.32.573-.504.955-.485.439-.019.853.204 1.078.58.248-.388.688-.61 1.147-.58l-.137-.002zm18.063-.012c.172.001.342.031.505.089l-.219.683c-.14-.057-.292-.084-.443-.082-.45 0-.683.3-.683.84V4.79h-.71V1.528h.703v.396c.178-.305.508-.488.86-.478l-.013-.014zm9.858 0c.172.001.343.031.505.089l-.218.683c-.141-.057-.292-.084-.444-.082-.45 0-.682.3-.682.84V4.79h-.71V1.528h.703v.396c.177-.305.507-.488.86-.478l-.014-.014zm2.489.8c-.536-.02-.99.391-1.022.927-.018.273.079.54.267.739.188.198.45.309.723.305.536-.003.972-.434.98-.97.01-.536-.412-.981-.948-1.001zm-26.607 0c-.536-.02-.99.391-1.021.927-.025.274.072.543.262.741.189.199.453.309.727.303.537-.003.973-.434.981-.97.009-.536-.413-.981-.949-1.001zm20.014-.007c-.536-.02-.99.392-1.021.927-.019.273.078.54.266.739.188.198.45.309.723.305.537-.002.972-.433.981-.97.009-.536-.413-.981-.949-1.001zm-9.587-.144h-.013c-.456-.016-.841.336-.867.791h1.706c-.004-.214-.094-.418-.249-.567-.155-.148-.362-.229-.577-.224z"
      />
      <path
        id="prefix__mastercard_c"
        d="M0.544 0.668L11.293 0.668 11.293 19.986 0.544 19.986z"
      />
      <path
        id="prefix__mastercard_e"
        d="M3.302 3.993C7.648-.713 14.882-1.29 19.918 2.668c-2.966 2.328-4.696 5.89-4.692 9.66-.003 3.77 1.727 7.331 4.692 9.658-5.037 3.958-12.27 3.382-16.616-1.324-4.346-4.707-4.346-11.963 0-16.67z"
      />
      <path
        id="prefix__mastercard_g"
        d="M13.88 1.276c4.23 2.056 6.916 6.346 6.916 11.05v.003c0 4.703-2.686 8.994-6.917 11.05-4.23 2.055-9.263 1.514-12.96-1.393 2.963-2.329 4.693-5.89 4.693-9.659 0-3.769-1.73-7.33-4.694-9.659C4.616-.239 9.648-.779 13.88 1.276z"
      />
      <path
        id="prefix__mastercard_i"
        d="M1 0.461L1.144 0.802 1.287 0.461 1.41 0.461 1.41 0.939 1.338 0.942 1.338 0.58 1.205 0.891 1.113 0.891 0.98 0.58 0.98 0.939 0.891 0.939 0.891 0.461z"
      />
    </defs>
    <g fill="none" fillRule="evenodd" transform="translate(28 5)">
      <g transform="translate(2 26)">
        <mask id="prefix__mastercard_b" fill="#fff">
          <use xlinkHref="#prefix__mastercard_a" />
        </mask>
        <path
          fill="#231F20"
          d="M-4.898 -4.783L42.385 -4.783 42.385 9.961 -4.898 9.961z"
          mask="url(#prefix__mastercard_b)"
        />
      </g>
      <g transform="translate(14 2)">
        <mask id="prefix__mastercard_d" fill="#fff">
          <use xlinkHref="#prefix__mastercard_c" />
        </mask>
        <path
          fill="#FF5F00"
          d="M-4.456 -4.332L16.293 -4.332 16.293 24.986 -4.456 24.986z"
          mask="url(#prefix__mastercard_d)"
        />
      </g>
      <mask id="prefix__mastercard_f" fill="#fff">
        <use xlinkHref="#prefix__mastercard_e" />
      </mask>
      <path
        fill="#EB001B"
        d="M-4.957 -4.958L24.918 -4.958 24.918 29.612 -4.957 29.612z"
        mask="url(#prefix__mastercard_f)"
      />
      <g transform="translate(19)">
        <mask id="prefix__mastercard_h" fill="#fff">
          <use xlinkHref="#prefix__mastercard_g" />
        </mask>
        <path
          fill="#F79E1B"
          d="M-4.082 -4.959L25.796 -4.959 25.796 29.613 -4.082 29.613z"
          mask="url(#prefix__mastercard_h)"
        />
      </g>
      <g transform="translate(38 19)">
        <mask id="prefix__mastercard_j" fill="#fff">
          <use xlinkHref="#prefix__mastercard_i" />
        </mask>
        <path
          fill="#F79E1B"
          d="M-4.624 -4.539L6.41 -4.539 6.41 5.942 -4.624 5.942z"
          mask="url(#prefix__mastercard_j)"
        />
      </g>
    </g>
  </svg>
);

export { MastercardIcon };
